import React from "react";
import {
  Section,
  SectionHeading,
  CardsGrid,
  StatCard,
  StatNumber,
  StatBody,
  cardBg
} from "./styled.components";

const cards = [
  {
    bg: cardBg.purple,
    stat: "33M",
    body: <span>Americans currently living with food allergies</span>
  },
  {
    bg: cardBg.blue,
    stat: "1 in 13",
    body: (
      <span>
        Children in the U.S. has a food allergy &mdash; that&rsquo;s roughly{" "}
        <strong>2 students in every classroom</strong>
      </span>
    )
  },
  {
    bg: cardBg.green,
    stat: "Every 3 Minutes",
    body: (
      <span>
        A food allergy reaction sends someone to the emergency department in the
        U.S.
      </span>
    )
  },
  {
    bg: cardBg.darkBlue,
    stat: "40%",
    body: (
      <span>
        Of children with food allergies have had a severe or life-threatening
        reaction
      </span>
    )
  }
];

const WhyThisWorkMatters: React.FC = () => (
  <Section>
    <SectionHeading>Why This Work Matters</SectionHeading>
    <CardsGrid>
      {cards.map((card, i) => (
        <StatCard key={i} bg={card.bg}>
          <StatNumber>{card.stat}</StatNumber>
          <StatBody>{card.body}</StatBody>
        </StatCard>
      ))}
    </CardsGrid>
  </Section>
);

export default WhyThisWorkMatters;
